module.exports = __webpack_public_path__ + "static/img/bkg.bbf3c111.png";